import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getDataTableByFormIDAndFeatureID,
    initDataTableStandAloneEditor
} from "@/helpers/datatable/datatable-standalone-editor-helper";
import {disableMoveLayer, moveLayer} from "@/helpers/ol/map/ol-move-helper";
import {getFeatureByFeatureID} from "@/helpers/ol/ol-feature-helper";
import {hideElementsBySelector} from "@/helpers/element-helper";
import {setActiveMutationGeometry} from "@/helpers/tools/tools-mutation-helper";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {initPopper} from "@/modules/popper";
import {getBookmarkPresentationsByID, getProjectionByBookmarkPresentationID} from "@/helpers/ol/ol-layer-helper";
import {setDrawGeometry} from "@/helpers/ol/draw/ol-draw-polygon-helper.js";

export class LayerInfoInfoItemMutationStandaloneEditGeometrySaveComponent extends HTMLElement {
    constructor(){
        super();
        const template = document.createElement('template');
        const formID = this.getAttribute('data-form-id')
        const featureID = this.getAttribute('data-feature-id')

        template.innerHTML = `
<button class="btn btn-sm icon-btn btn-success btn-sm popper-header text-transform-none">
    <span class="fa fa-check"></span>
    <div class="popper-tooltip" role="tooltip" data-popper-placement="bottom">
         Opslaan
        <div class="arrow" data-popper-arrow=""></div>
     </div>
</button>
`
        initWebComponent(this, template)

        initPopper()

        this.addEventListener('click', () => {
            hideElementsBySelector('layer-info-info-mutation-standalone-edit-geometry-save')
            hideElementsBySelector('layer-info-info-mutation-standalone-edit-geometry-cancel')
            const dataTable = getDataTableByFormIDAndFeatureID(formID, featureID)

            const bookmarkPresentation = getBookmarkPresentationsByID(dataTable.BookmarkPresentationID)

            const geometry = getFeatureByFeatureID(dataTable.BookmarkPresentationID, dataTable.FeatureID, bookmarkPresentation.PrimaryKeyName).clone().getGeometry()
            setActiveMutationGeometry(geometry, getViewProjectionName(), bookmarkPresentation.Service.Projection)
            initDataTableStandAloneEditor(dataTable, 'edit')
            disableMoveLayer()
        })
    }
}
